import React from "react";
import {Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Navbar from "./Navbar";
import Assignments from "./Assignments";
import FinalProject from "./pages/assignments/FinalProject";
import Home from "./Home";
import About from "./About";
import './index.css';
import Assignment1 from "./pages/assignments/Assignment1";
import Assignment2 from "./pages/assignments/Assignment2";
import Assignment3 from "./pages/assignments/Assignment3";
import Assignment4 from "./pages/assignments/Assignment4";
import Assignment5 from "./pages/assignments/Assignment5";
import Assignment6 from "./pages/assignments/Assignment6";
import Assignment7 from "./pages/assignments/Assignment7";
import Assignment8 from "./pages/assignments/Assignment8";
import Assignment9 from "./pages/assignments/Assignment9";
import Assignment10 from "./pages/assignments/Assignment10";
import Assignment11 from "./pages/assignments/Assignment11";
import Assignment12 from "./pages/assignments/Assignment12";
import Assignment13 from "./pages/assignments/Assignment13";
import Assignment14 from "./pages/assignments/Assignment14";
import Assignment15 from "./pages/assignments/Assignment15";
import Assignment16 from "./pages/assignments/Assignment16";
import Assignment17 from "./pages/assignments/Assignment17";
import Assignment18 from "./pages/assignments/Assignment18";
import Assignment19 from "./pages/assignments/Assignment19";

const App = () => {

  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Navigate to="/home" />}></Route>
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About/>}></Route>
        <Route path="/final-project" element={<FinalProject />} />
        <Route path="/assignments" element={<Assignments />} />
        <Route path="/assignments/1" element={<Assignment1 />} />
        <Route path="/assignments/2" element={<Assignment2 />} />
        <Route path="/assignments/3" element={<Assignment3 />} />
        <Route path="/assignments/4" element={<Assignment4 />} />
        <Route path="/assignments/5" element={<Assignment5 />} />
        <Route path="/assignments/6" element={<Assignment6 />} />
        <Route path="/assignments/7" element={<Assignment7 />} />
        <Route path="/assignments/8" element={<Assignment8 />} />
        <Route path="/assignments/9" element={<Assignment9 />} />
        <Route path="/assignments/10" element={<Assignment10 />} />
        <Route path="/assignments/11" element={<Assignment11 />} />
        <Route path="/assignments/12" element={<Assignment12 />} />
        <Route path="/assignments/13" element={<Assignment13 />} />
        <Route path="/assignments/14" element={<Assignment14 />} />
        <Route path="/assignments/15" element={<Assignment15 />} />
        <Route path="/assignments/16" element={<Assignment16 />} />
        <Route path="/assignments/17" element={<Assignment17 />} />
        <Route path="/assignments/18" element={<Assignment18 />} />
        <Route path="/assignments/19" element={<Assignment19 />} />
        <Route path="/assignment/20" element={<FinalProject />} />
      </Routes>

    </div>
    
  );
};

export default App;
